export default "/app/6729d29753e000c17489ed43135ba8d5.svg";